const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getVehicleInfoByModeCode({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleMatching/getVehicleMatchingInfo", params);
      return data;
    }
  }
};

export default store;
